
export default {
  isApp () {
    return true
  },
  getToken () {
    return getSession('token')
  },
  checkToken (access = () => { }) {
    // 是否在浏览器分享页面
    if (this.isShare) {
      this.openApp()
      return false
    } else {
      // 验证token
      if (!this.getToken()) {
        this.nativeLogin()
        return false
      } else {
        access()
        return true
      }
    }
  },
  openApp (tid) {
    // window.open()
    // let url = 'https://www.csmar.com/app/?cUrl=pages/index/detail?tid=15'
    let isIOS = getSession('isIOS')
    let isAndroid = getSession('isAndroid')
    let url = ''
    let browerObj = this.browserVersions()
    console.log('打开app时传递的tid', tid)
    if (isAndroid) {
      // 如果是微信和QQ，无法直接打开
      if (browerObj.weixin) {
        console.log('微信或者QQ浏览器', url)
        const oInput = document.createElement('input');
        oInput.value = 'https://www.csmar.com/app/forum?tid=' + tid;
        document.body.appendChild(oInput);
        oInput.select();
        // const copyResult = document.execCommand('copy');
        document.body.removeChild(oInput);
        url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.csmar.edu&android_schema=csmarysm://forum?tid=' + tid + '&ios_schema=csmarysm://forum?tid=' + tid
        window.open(url)
      } else {
        url = 'csmarysm://forum/?tid=' + tid
        window.open(url)
      }
    }
    if (isIOS) {
      let isQQ = browerObj.qq
      if (isQQ) {
        const oInput = document.createElement('input')
        oInput.value = 'https://www.csmar.com/app/forum?tid=' + tid
        document.body.appendChild(oInput)
        oInput.select()
        // const copyResult = document.execCommand('copy')
        document.body.removeChild(oInput)
        url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.csmar.edu&android_schema=csmarysm://forum?tid=' + tid + '&ios_schema=csmarysm://forum?tid=' + tid
        window.location.href = url
      } else {
        url = 'https://www.csmar.com/app/forum?tid=' + tid
        window.location.href = url
      }
    }
    console.log('打开app url', url)
  },
  nativeBack () {
    let isAndroid = getSession('isAndroid')
    let isIOS = getSession('isIOS')
    // 获取原生的状态栏高度
    if (isAndroid) {
      window.ytyJsApi.backUp()
    } else if (isIOS) {
      window.webkit.messageHandlers.backUp.postMessage(1);
    }
  },
  nativeLogin () {
    let isAndroid = getSession('isAndroid')
    let isIOS = getSession('isIOS')
    if (isIOS) {
      window.webkit.messageHandlers.goLogin.postMessage(1);
    }
    if (isAndroid) {
      window.ytyJsApi.goLogin()
    }
  },
  browserVersions () {
    let u = navigator.userAgent;
    let app = navigator.appVersion;
    console.log('浏览器信息', u)
    console.log('浏览器APP版本', app)
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, // 是否微信
      qq: u.match(/\sQQ/i) // 是否QQ
    };
  },
  getUserData (option) {
    return getUserinfo({ token: option.token }).then(res => {
      setSession('userInfo', res.data)
    })
  },
  /**
     ** 乘法函数，用来得到精确的乘法结果
     ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
     ** 调用：accMul(arg1,arg2)
     ** 返回值：arg1乘以 arg2的精确结果
     **/
  accMul (num1, num2) {
    let m = 0;
    let s1 = num1.toString();
    let s2 = num2.toString();
    try { m += s1.split('.')[1].length } catch (e) { }
    try { m += s2.split('.')[1].length } catch (e) { }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
  },
  /**
     * 转化数字为几位小数，四舍五入或者截取多于位数
     * num     [需转化的数字]
     * @param  {Number} [digit=2]   [需保留或截取的位数]
     * @param  {Boolean} [isRround=true]            [true四舍五入，false截取多于小数]
     * */

  formatDate: function (date, format) {
    return dateFormat(date, format)
  },
  // 两数相除
  accDiv (num1, num2) {
    var t1, t2, r1, r2;
    try {
      t1 = num1.toString().split('.')[1].length;
    } catch (e) {
      t1 = 0;
    }
    try {
      t2 = num2.toString().split('.')[1].length;
    } catch (e) {
      t2 = 0;
    }
    r1 = Number(num1.toString().replace('.', ''));
    r2 = Number(num2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  },
  round (value, fixedLen = 2) {
    return value.toFixed(fixedLen);
  },
  formatNumUnit (value, fixedLen = 2, num = 10000) {
    if (value === '--') {
      return value;
    }
    if (value == null) {
      return '--'
    }
    var result = {};
    var k = 10000;
    var sizes = ['', '万', '亿', '万亿'];
    var i;
    if (value < num) {
      result.value = value;
      result.unit = '';
    } else {
      i = Math.floor(Math.log(value) / Math.log(k));

      result.value = this.round(value / Math.pow(k, i), fixedLen);
      result.unit = sizes[i];
    }
    return result.value + result.unit;
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/js/mixin.js